import { DialogSignInComponent } from '@modules/auth/dialog-sign-in/dialog-sign-in.component';

export enum DIALOGS {
  signIn = 'signIn',
}

export const dialogList = {
  [DIALOGS.signIn]: DialogSignInComponent,
};
